import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const englishIqSupplyIssueSchema = z.object({
  available: z.number().int().nonnegative(),
  plan: z.string(),
  renderer: z.string(),
  required: z.number().int().nonnegative(),
  score: z.number(),
  skill: z.string(),
});

const getEnglishIqSupplyV1DataSchema = z.object({
  assessmentVersion: z.number().int().positive(),
  candidateCount: z.number().int().nonnegative(),
  checkedAt: z.number().int().nonnegative(),
  issues: z.array(englishIqSupplyIssueSchema),
  valid: z.boolean(),
});

export type IGetEnglishIqSupplyV1Data = z.infer<typeof getEnglishIqSupplyV1DataSchema>;

export const getEnglishIqSupplyV1ResponseSchema: z.ZodSchema<IAPI<IGetEnglishIqSupplyV1Data>> =
  createApiResponseSchema(getEnglishIqSupplyV1DataSchema) as z.ZodSchema<
    IAPI<IGetEnglishIqSupplyV1Data>
  >;

export type IGetEnglishIqSupplyV1Response = IAPI<IGetEnglishIqSupplyV1Data>;
